<template>
  <div v-if="showTagsSlider" id="tagSlider" refs="tagSlider"
    :data-elheight="elementHeight"
    :class="['top-slider-filter', accessorComponent, {
      'expanded': expanded,
      'media-page-tags-slider': isComponentUseInFilesPage
    }]">
    <div class="background white-background"></div>

    <perfect-scrollbar
      id="tagsSliderPresentation"
      ref="tagsSliderPresentation"
      :class="['workspace cstm-ps-scrollbar-vertical', {'has-data': tags.length, 'hide-ps-rail-y-onHover': !expanded}]"
      @ps-scroll-y="handleContentScrollY">

      <draggable
        v-bind="sortDraggableOptions"
        id="tagSliderContent"
        class="workspace leading-[1.5]"
        tag="div"
        ghost-class="sortable-ghost"
        filter="._toSeeAllData"
        :preventOnFilter="true"
        :list="tags"
        :item-key="(item) => item?.value"
        :group="{ name: 'tags-shared', pull: 'clone', put: false }"
        :sort="false"
        :disabled="!isTagElDraggable"
        :forceFallback="true"
        :move="handleDraggableMove"
        @end="handleDraggableEnd"
      >
        <template #item="{ element: tag, index: tagIndex }">
          <el-tag
            :class="[
              'el-tag-tagSlider',
              `el-tag-${accessorComponent}`,
              {'_toSeeAllData': tag.value === CONST.ALL_TAG_VALUE,
              'edit-tag': editTags.find(t => t.value === tag.value),
              'premium': tag.value.toLowerCase() === 'premium',
              'selected': selectedTags.find(t => t.value === tag.value) || (tag.value === CONST.ALL_TAG_VALUE && selectedTags.length === 0),
              'hide': tag.hide
            }]"
            data-draggable-type="tag"
            :data-draggable-value="tag.value"
          >
            <div class="background-color" :style="{'backgroundColor': (tag.backgroundColor ? tag.backgroundColor: '')}"></div>
            <div @click="handleTagItemClick($event, tag, tagIndex)" class="tag-val">
              <span v-if="tag.value === CONST.ALL_TAG_VALUE">{{tag.label}}</span>
              <span v-else-if="tag.showLabel">{{tag.showLabel}}</span>
              <span v-else>{{tag.value}}</span>

              <el-input
                id="tag-slider-input"
                :model-value="editTagValue"
                @update:model-value="newValue => editTagValue = newValue"
                :ref='`editTagInput${tagIndex}`'
                @blur="handleConfirmEditTag(editTagValue, tag.value)"
                class="edit-tag-input">
              </el-input>
            </div>
            <div v-if="enableDeleteTags" @click="confirmDeleteTag($event, tag, tagIndex)" class="remove-icon"></div>
          </el-tag>
        </template>
      </draggable>
    </perfect-scrollbar>

    <div id="tagSliderCollapseIcon"
      :class="[{'show-icon': showExpandIcon, 'expanded': expanded}]"
      @click="handleExpandComponentIconClick()">
      <el-icon :size="20"><ArrowDown /></el-icon>
    </div>
  </div>
</template>

<script src="./tag-slider.js"></script>
<style lang="scss" src="./tag-slider.scss"></style>
